import { Button, Card, Space, Typography } from 'antd'
import { useAppSelector } from '../../store/hooks'
import { Automation } from '../../models/Automation'
import PageTitle from '../PageTitle'
import { Actions } from '../../modules/sbrm/components/Actions'
import { MetaDataKey } from '../../modules/sbrm/models/MetaData'
import { SBRMType } from '../../modules/sbrm/SBRMModel'
import { Answer } from './Answer'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { PlusOutlined } from '@ant-design/icons'
const { Text } = Typography

interface Props {
  automation?: Automation
  forFollower: boolean
  isEditing?: boolean
}

export const AnswerCard = ({
  automation,
  forFollower,
  isEditing = true,
}: Props) => {
  return (
    <>
      {automation && (
        <Card
          style={{ border: '2px solid #a68aeb' }}
          styles={{ body: { padding: 0 }, header: { padding: 10 } }}
          title={
            <Space
              className="w-full"
              style={{ justifyContent: 'space-between' }}
            >
              <Text strong>
                {i18n.t(
                  forFollower
                    ? LocalizationKeys.Component.Answer.Card.IfUserIsFollower
                    : LocalizationKeys.Component.Answer.Card.IfUserIsNotFollower
                )}
              </Text>
              {isEditing && (
                <Actions
                  trigger={
                    <>
                      <Button
                        type="primary"
                        className="hide-mobile gleap-create-answer"
                      >
                        {i18n.t(LocalizationKeys.SBRM.AddNew)}
                      </Button>
                      <Button
                        type="primary"
                        className="d-none-lg"
                        icon={<PlusOutlined />}
                      />
                    </>
                  }
                  entity={SBRMType.answer}
                  actions={['create']}
                  metadata={[
                    { key: MetaDataKey.forFollower, value: forFollower },
                    { key: MetaDataKey.automationId, value: automation.id },
                  ]}
                />
              )}
            </Space>
          }
        >
          <Answer.List
            ids={
              forFollower
                ? automation.followerAnswers
                : automation.notFollowerAnswers
            }
            isEditing={isEditing}
          />
        </Card>
      )}
    </>
  )
}

export type AnswerCardType = { Card: typeof AnswerCard }
